@if (isActionable) { @if (isStatusAvailable()) {
<div
  class="recorder-status"
  [class.recorder-status-danger]="isStorageBlocked()"
  [class.recorder-status-warn]="isStorageWarn()"
>
  <av-tooltip
    [message]="storageStatusMessage()"
    [wrap]="true"
    position="bottom"
  >
    <av-icon
      name="info"
      size="xs"
      [mode]="isStorageBlocked() ? 'light' : 'dark'"
    ></av-icon>
  </av-tooltip>
</div>
}
<av-tooltip position="bottom">
  <button
    aria-labelledby="recorder-tooltip-message"
    avButton
    size="xxs"
    ofType="basic"
    id="btn-recorder-start"
    [class.recorder-on]="isRecorderActive || isRecordingRemotely()"
    (click)="toggleRecorder()"
    [disabled]="
      isRecorderButtonDisabled || isRecordingRemotely() || isStorageBlocked()
    "
    class="recorder"
    data-tid="recorder/toggle-recorder"
  >
    <div class="recorder-indicator"></div>
    <span>REC</span>
  </button>
  <span id="recorder-tooltip-message" tooltipMessage>
    @if (!isRecorderActive) { @if (!isRecordingRemotely()) { @if
    (isRecorderConfigured) {
    {{ "start recording" | translate }}
    } @if (!isRecorderConfigured) {
    {{
      "Recording disabled. Contact your administrator to enable." | translate
    }}
    } } @if (isRecordingRemotely()) {
    {{ "Session is being recorded" | translate }}
    } } @if (isRecorderActive) { @if (!isRecordingRemotely()) { @if
    (isRecorderLocked) {
    {{ "Recording is locked" | translate }}
    } @if (!isRecorderLocked) {
    {{ "stop recording" | translate }}
    } } @if (isRecordingRemotely()) {
    {{ "Session is being recorded" | translate }}
    } }
  </span>
</av-tooltip>
} @if (isReadOnly) {
<av-tooltip position="bottom">
  <div
    aria-labelledby="recorder-tooltip-message"
    [class.recorder-on]="isRecordingRemotely()"
    class="recorder recorder-view"
    data-tid="recorder/customer"
  >
    <div class="recorder-indicator"></div>
    <span>REC</span>
  </div>
  <span id="recorder-tooltip-message" tooltipMessage>
    @if (isRecordingRemotely()) {
    {{ "Session is being recorded" | translate }}
    } @if (!isRecordingRemotely()) {
    {{ "Session is not recorded" | translate }}
    }
  </span>
</av-tooltip>
}
